export default __webpack_public_path__ + "static/media/Paramodernities.706703f4.jpg";